import classNames from 'classnames';

import { ID } from '../../../../../../../types';
import {
  LifestyleDetectionDetectRequestID,
  LifestyleDetectionID
} from '../../../../../../lifestyleDetections/lifestyleDetectionsTypes';

import { ImageSelectionPayload } from '../../../ThreeDStockContentImageLens';
import { ThreeDStockContentSearchInImageView } from '../../ThreeDStockContentSearchInImageTypes';

import { FetchLifestyleDetection } from '../../../../../../lifestyleDetections/queries/lifestyleDetectionsByImageUrl.query';

import { useThreeDStockContentSearchInImageDetections } from './hooks/useThreeDStockContentSearchInImageDetections';

import { ThreeDStockContentImageLens } from '../../../ThreeDStockContentImageLens';
import { ThreeDStockContentSearchInImageAllObjects } from '../ThreeDStockContentSearchInImageAllObjects';

interface ThreeDStockContentSearchInImageDetectionsProps {
  imageUrl: string;
  view: ThreeDStockContentSearchInImageView;
  imageId?: ID;
  lifestyleId?: ID;
  onSelectedImage?: (
    payload: ImageSelectionPayload,
    detectRequestId: LifestyleDetectionDetectRequestID,
    lifestyleDetectionId?: LifestyleDetectionID
  ) => void;
  onClearSearch?: () => void;
  onDetectionsChange?: (detections: FetchLifestyleDetection[]) => void;
  activeDetectionId?: ID | null;
  onActiveDetectionChange?: (id: ID | null) => void;
}

function ThreeDStockContentSearchInImageDetections({
  imageUrl,
  view,
  imageId,
  lifestyleId,
  onSelectedImage,
  onClearSearch,
  onDetectionsChange,
  activeDetectionId,
  onActiveDetectionChange
}: ThreeDStockContentSearchInImageDetectionsProps) {
  const {
    lifestyleDetections,
    initialSelection,
    isLoading,
    onResolveSingleClickSelection,
    handleSelectedImage
  } = useThreeDStockContentSearchInImageDetections({
    imageUrl,
    imageId,
    lifestyleId,
    onSelectedImage,
    onDetectionsChange
  });

  return (
    <div className="w-full">
      <div className="grid">
        <div
          className={classNames('col-start-1 row-start-1 min-w-0', {
            invisible: view !== 'single'
          })}
          aria-hidden={view !== 'single'}
        >
          <ThreeDStockContentImageLens
            imageUrl={imageUrl}
            initialSelection={initialSelection}
            isLoading={isLoading}
            onClearSearch={onClearSearch}
            onResolveSingleClickSelection={onResolveSingleClickSelection}
            onSelectedImage={handleSelectedImage}
          />
        </div>
        <div
          className={classNames('col-start-1 row-start-1 min-w-0', {
            invisible: view !== 'all'
          })}
          aria-hidden={view !== 'all'}
        >
          <ThreeDStockContentSearchInImageAllObjects
            imageUrl={imageUrl}
            detections={lifestyleDetections}
            activeDetectionId={activeDetectionId}
            onActiveDetectionChange={onActiveDetectionChange}
            isLoading={isLoading}
            onClearSearch={onClearSearch}
          />
        </div>
      </div>
    </div>
  );
}

export default ThreeDStockContentSearchInImageDetections;
